import type { GuestBusinessDetailsRecord } from "@/api/guest-business-details";
import { COUNTRIES } from "@/constants/countries";

const USA_COUNTRY_ID = 3;

export type BusinessDetailsFormInitialValues = {
	business_name: string;
	address: string;
	address_line_2: string;
	city: string;
	zipcode: string;
	global_state_id: number;
	business_phone: string;
	business_phone_global_country_id: number;
	ein_number: string;
};

export const EMPTY_FORM_VALUES: BusinessDetailsFormInitialValues = {
	business_name: "",
	address: "",
	address_line_2: "",
	city: "",
	zipcode: "",
	global_state_id: USA_COUNTRY_ID,
	business_phone: "",
	business_phone_global_country_id: 0,
	ein_number: "",
};

export function formatEinInput(value: string): string {
	const digits = value.replace(/\D/g, "").slice(0, 9);
	if (digits.length <= 2) return digits;
	return `${digits.slice(0, 2)}-${digits.slice(2)}`;
}

export function formatEinForDisplay(ein: string | null): string {
	if (!ein) return "";
	return formatEinInput(ein.replace(/\D/g, ""));
}

export function einToPayload(value: string): string | null {
	const digits = value.replace(/\D/g, "");
	if (!digits) return null;
	return formatEinInput(digits);
}

function formatInitialPhoneDigits(
	phoneNumber: string,
	countryId: number,
): string {
	const country = Object.values(COUNTRIES).find(
		(c) => c.id === String(countryId),
	);
	const dial = country?.secondary ?? "";
	return `${dial}${phoneNumber}`.replace(/\D/g, "");
}

export function recordToFormValues(
	record: GuestBusinessDetailsRecord,
): BusinessDetailsFormInitialValues {
	return {
		business_name: record.business_name,
		address: record.address,
		address_line_2: record.address_line_2 ?? "",
		city: record.city,
		zipcode: record.zipcode,
		global_state_id: record.global_state_id,
		business_phone: formatInitialPhoneDigits(
			record.business_phone,
			record.business_phone_global_country_id,
		),
		business_phone_global_country_id: record.business_phone_global_country_id,
		ein_number: formatEinForDisplay(record.ein_number),
	};
}
